import { useEffect, useState, forwardRef } from 'react'
import { Sprite } from '@pixi/react'
import { SpriteProps } from '../type/PixiType'
import { Assets, Sprite as PixiSprite } from 'pixi.js'
import { FixedContainerV2 } from './FixedContainer'
export const Image = forwardRef<PixiSprite, SpriteProps>((props, ref) => {
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    setIsLoading(true)

    if (props.image !== undefined) {
      const exists = Assets.cache.has(props.image.toString())
      if (!exists) {
        console.warn('Image not found in assets cache:', props.image, ' ,starting to load it.')
        Assets.load(props.image).then(() => {
          setIsLoading(false)
        })
      }
      else {
        setIsLoading(false)
      }
    }
  }, [props.image])

  if (isLoading)
    return (
      <FixedContainerV2 width={props.width ?? 0} height={props.height ?? 0} x={props.x ?? 0} y={props.y ?? 0}>
      </FixedContainerV2>
    )

  return (
    <Sprite {...props} ref={ref} />
  )
})
